<template>
  <div>
    <div class="sellerInformation" v-show="step == 1">
      <div class="sellerInformation-top">
        <div class="top-con">
          <div class="container">
            <img src="@/assets/image/Contract/sell_info.png" />
            <span>订单编号：{{ order_no }}</span>
          </div>
          <div class="logo"></div>
        </div>
      </div>
      <div class="sellerInformation-main">
        <div class="certContractSign-card-body">
          <el-form
            class="certContractSign-card-body-form"
            :label-width="labelWidth"
            :label-position="labelPostion"
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
          >
            <!-- 下半部分 -->
            <div class="certContractSign-card-body-form-bottom">
              <div class="certContractSign-card-body-form-top-title bottom-title">
                <span class="certContractSign-card-body-form-top-title-gameinfo" style="letter-spacing: 4px;"
                  >签约人信息</span
                >
                <img src="@/assets/image/Contract/danger.png" alt="" />
                <span class="certContractSign-card-body-form-bottom-tip"
                  >签署电子合同需保证实名，且需年满18周岁</span
                >
              </div>
              <div class="certContractSign-card-body-form-bottom-content">
                <ContractingParty :countryList="countryList" :partyData="partyData" @handleActive="handleActive" @refreshData="getSignatoryList()" v-if="ruleForm.contract_agent_sign == 1 || underage"></ContractingParty>
                <template v-else>
                  <el-form-item
                    label="签约人"
                    class="certContractSign-card-body-form-bottom-content-realname realInfo"
                    v-model="ruleForm.auth_state"
                    prop="auth_state"
                  >
                    <div
                      v-if="!ruleForm.auth_state"
                      class="real"
                    >
                      <span @click="certification">点击实名认证</span>
                    </div>
                    <div v-else style="color: #333333" class="real">
                      <span @click="certification">已认证</span>
                    </div>
                  </el-form-item>
                  <el-form-item
                    label="手机号"
                    class="certContractSign-card-body-form-bottom-content-realname"
                    prop="phone"
                  >
                    <template #error>
                      <div class="prop-fail">
                        <img src="@/assets/image/Contract/err.png" alt="" />
                        <span>请输入正确的手机号</span>
                      </div>
                    </template>
                    <el-input
                      placeholder="请输入手机号"
                      v-model="ruleForm.phone"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="联系地址" prop="country_type">
                    <el-radio-group v-model="ruleForm.country_type" @change="ruleForm.country_code = ''">
                      <el-radio :label="1">国内</el-radio>
                      <el-radio :label="2">国外</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="详细地址" prop="address">
                    <div class="domestic" v-if="ruleForm.country_type == 1">
                      <div
                        class="certContractSign-card-body-form-bottom-content-province province"
                      >
                        <el-select
                          placeholder="省"
                          class="select"
                          v-model="ruleForm.province"
                          clearable
                          filterable
                          @change="provinceChange"
                        >
                          <el-option
                            v-for="item in ChinaAddressArea"
                            :key="item.value"
                            :label="item.value"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                        <el-select
                          placeholder="市"
                          class="select"
                          v-model="ruleForm.city"
                          filterable
                          clearable
                          @change="cityChange"
                        >
                          <el-option
                            v-for="item in cityList"
                            :key="item.value"
                            :label="item.value"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                        <el-select
                          placeholder="区"
                          class="select"
                          v-model="ruleForm.area"
                          filterable
                          clearable
                        >
                          <el-option
                            v-for="item in districtList"
                            :key="item.value"
                            :label="item.value"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                      <el-input
                        placeholder="请输入详细地址"
                        class="certContractSign-card-body-form-bottom-content-address"
                        v-model="ruleForm.address"
                        show-word-limit
                        maxlength="100"
                      ></el-input>
                    </div>
                    <div class="abroad" v-else>
                      <el-select placeholder="国家" class="abroad-select" v-model="ruleForm.country_code">
                        <el-option
                          v-for="(item, index) in countryList"
                          :key="item.en + index"
                          :label="item.name"
                          :value="item.tel"
                        >
                        </el-option>
                      </el-select>
                      <el-input
                        placeholder="请输入详细地址"
                        class="certContractSign-card-body-form-bottom-content-address"
                        show-word-limit
                        maxlength="100"
                        v-model="ruleForm.address"
                        style="margin-top: 0;"
                      ></el-input>
                    </div>
                  </el-form-item>
                </template>
                <!-- 别处购买 中介订单 -->
                <el-form-item
                    v-if="ruleForm.acc_source == 5 && ruleForm.trade_type == 2"
                    class="certContractSign-card-body-form-top-content-from"
                    label="上传凭证"
                    prop="acc_source"
                  >
                    <div
                      class="certContractSign-card-body-form-top-content-uploadimg"
                    >
                      <div
                        class="certContractSign-card-body-form-top-content-uploadimg-img"
                      >
                        <el-upload
                          class="upload-box"
                          v-loading="loadingback"
                          action
                          :auto-upload="false"
                          list-type="picture-card"
                          :show-file-list="false"
                          :on-change="e => {uploadCardBehind(e, 'other_order_img')}">
                          <img v-if="ruleForm.other_order_img" :src="ruleForm.other_order_img" class="certContractSign-card-body-form-top-content-uploadimg-img-left">
                          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                          <div class="delete" v-if="ruleForm.other_order_img">
                            <i @click.stop="delOthenImg" class="el-icon-delete"></i>
                          </div>
                        </el-upload>
                        <!-- <img
                          src="@/assets/image/Contract/del.png"
                          @click="delAccImg"
                          class="certContractSign-card-body-form-top-content-uploadimg-img-right"
                        /> -->
                      </div>
                      <div
                        class="certContractSign-card-body-form-top-content-uploadimg-text"
                      >
                        外卖、网购订单凭证截图，<span style="color: #F56B6C;">收货人信息需和签约人一致，且订单日期需在6个月以内</span>，限bmp，jpg，png，jpeg图片格式，不超过5M
                      </div>
                    </div>
                  </el-form-item>
              </div>
            </div>
          </el-form>
          <div class="sellerInformation-btn">
            <el-button v-preventReClick='1500' :loading="btnLoading" @click="saveInfo" class="sub"
              >提交</el-button
            >
          </div>
          <!-- <div class="certContractSign-card-body-form-bottom-img">
            <img src="@/assets/image/Contract/fddTip.png" alt="" />
            <span>本平台电子合同由法大大提供技术支持</span>
          </div> -->
        </div>
      </div>
    </div>
    <realname-certification v-show="step == 2" @step="userToken ? step = 3 : step = 1" :app_status="app_status" @realNameSubmit="realNameSubmit" @underageChange="underage = true"></realname-certification>
    <sellerInformationMobile v-if="step == 3"></sellerInformationMobile>
    <!-- :btn-text="`去实名${_isMobile() ? '' : '(' + goRealNameTime + 'S)'}`" -->
    <myDialog
      title="实名认证"
      text="您提交的信息法大大未实名，请准备好身份证进行实名认证"
      btn-text="去实名"
      btn
      :show="showRealNameDialog"
      :close-fun="closeRealNameDialog"
      :btn-fuc="goRealName"
    >
      <div slot="tip" class="dialog-realname">
        <i class="el-icon-warning"></i>
        若实名不成功,请联系客服更换签约人信息
      </div>
    </myDialog>
  </div>
</template>

<script>
import { apiContractSellerInformation, apiSellCard, apiContractSellerInformationAdd, signatoryList} from "../../request/API";
import * as imageConversion from "image-conversion";
import realnameCertification from './realnameCertification.vue';
import sellerInformationMobile from './sellerInformationMobile.vue';
import { addressArea } from './newMap'
import ContractingParty from "./components/ContractingParty.vue";
import myDialog from "@/components/myDialog";
/**
 * 表单验证失败时 滚动到第一个error位置
 */
 const scrollIntoView = (className = "is-error", block = "center") => {
    Promise.resolve().then(() => {
       const target = document.getElementsByClassName(className);
     if (target.length) {
        target[0].scrollIntoView({
           behavior: "smooth",
           block: block,
       });
    }
  });
};

const is_mobile = navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
);
let codes = require('../../assets/json/coutryCode.json')
export default {
  components: {
    realnameCertification,
    sellerInformationMobile,
    ContractingParty,
    myDialog,
  },
  name: "submitSuccess",
  data() {
    return {
      lastUseList: [
        {label: '是', value: 1},
        {label: '否', value: 0},
      ],
      // 实名倒计时
      readnameUrl: '',
      goRealNameTime: 3,
      showRealNameDialog: false,
      // 签署人选中id
      signActiveId: '',
      // 是否未成年
      underage: false,
      // 游戏通行证是否禁用
      gameAccountDis: false,
      btnLoading: false,
      loading: false,
      ocrLoading: false,
      order_no: "",
      ruleForm: {
        game_account: '',
        acc_source: 0,
        acc_source_img: '',
        auth_state: "",
        phone: "",
        country_type: 1,
        province: "",
        city: "",
        area: "",
        address:"",
        cert_name: '',
        card_id: '',
        frontIdPhoto: '',
        backIdPhoto: '',
        location: '',
        country_code: '',
        other_order_img: '',
      },
      rules: {
        auth_state: [
          {required: true, validator: this.validatearmsData, trigger: 'blur'},
        ],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        country_type: [{ required: true, message: "请选择联系地址", trigger: "change" }],
        address: [
          { required: true, message: "请完善联系地址", trigger: "blur" },
          {
            min: 5,
            message: "请输入准确现住地址",
            trigger: "blur",
          },
        ],
      },
      provinceList: [],
      cityList: [],
      districtList: [],
      countryList: codes.splice(4,codes.length),
      ChinaAddressArea: [],
      // 订单id
      order_id: '',
      // 房间id
      room_id: '',
      // token
      userToken: '',
      loadingback: false,
      app_status: 1,
      admin_id: '',
      step: 1,
      flag: true,
      id: '',
      auditStatus: '',
      //登陆方式
      accSourceList: [
        {label: '自己注册', value: 0},
        {label: '游严选购买', value: 1},
        {label: '别处购买', value: 5},
      ],
      //联系地址
      countryTypeList:[
        {label: '国内', value: 1},
        {label: '国外', value: 2},
      ],
      //签约信息表单 手机端
      editPartyShow:false,
      editPartyForm: {
        last_use: 1,
        name:'',
        card_id:'',
        phone:'',
        country_type:1,
        province:'',
        city:'',
        area:'',
        address:'',
        country_code:'',
      },
      editPartyRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        card_id: [{ required: true, message: "请输入身份证号", trigger: "blur" }],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        country_type: [{ required: true, message: "请选择联系地址", trigger: "change" }],
        address: [
          { required: true, message: "请完善联系地址", trigger: "blur" },
          {
            min: 5,
            message: "请输入准确现住地址",
            trigger: "blur",
          },
        ],
      },
      //签约人列表
      partyData:[],
      // 当前选中签约人index
      signActiveIndex: 0,
    };
  },
  computed: {
    labelPostion() {
      return is_mobile ? "top" : "left";
    },
    labelWidth() {
      return is_mobile ? "auto" : "136px";
    },
  },
  created() {
    this.order_id = this.$route.query.o
    this.room_id = this.$route.query.r
    this.admin_id = this.$route.query.a
    this.userToken = this.$route.query?.t || this.$route.query?.token
    let f = this.$route.query?.f
    if(f){
      this.flag = f == 1 ?  false : true
    }

    if(this.userToken){
      let status = true
      this.$store.commit('set_token', this.userToken)
      this.$store.commit('set_loginStatus', status)
      this.app_status = 2
    } else{
      if (this.$store.state.loginStatus) {
        this.app_status = 1
      } else{
        this.$router.push({
          path: '/login',
          query: {
            Rurl: this.$route.fullPath
          },
        })
        return;
      }
    }
    apiContractSellerInformation({
      rd: this.$route.query.rd,
      order_id: this.order_id,
      client: this.userToken ? 'moblie' : 'front'
    }).then(res => {
      this.id = res.data.id
      this.auditStatus = res.data.status
      this.order_no = res.data.order_no
      this.ruleForm = res.data
      if (this.userToken) {
        this.step = 3
      }
      // if(this.ruleForm.game_account != ''){
      //   this.gameAccountDis = true
      // }
      if(Number(this.id)>0 && Number(this.auditStatus)>=0 && this.flag){
        location.href = `/submitOutcome?r=${this.room_id}&a=${this.admin_id}&o=${this.order_id}${this.userToken?'&t=' + this.userToken: ''}`
      }

      try{
        this.provinceChange(this.ruleForm.province,true)
        // this.cityChange(this.ruleForm.city,true)
      }catch {}
    }).catch(err => {
      this.$message({
        message: err.msg,
        center: true,
        offset: 200,
        customClass: 'sell-contract-msg'
      })
      setTimeout(() => {
        this.$router.push({
          path: '/login',
          query: {
            Rurl: this.$route.fullPath
          },
        })
      },3000)
    })
    this.getSignatoryList()
  },
  mounted() {
    this.ChinaAddressArea = addressArea
  },
  methods: {
    handleActive({id,index}){
      this.signActiveIndex = index
      this.signActiveId = id
      this.ruleForm.other_order_img = this.partyData[index].other_order_img
    },
    /**
     * @description: 重置
     * @return {*}
     */
    resetInfo() {
      this.ruleForm.game_account = ''
      this.ruleForm.acc_source = 0
      this.ruleForm.acc_source_img = ''
      this.ruleForm.phone = ''
      this.ruleForm.country_type = 1
      this.ruleForm.province =  ''
      this.ruleForm.city =  ''
      this.ruleForm.area =  ''
      this.ruleForm.address =  ''
      this.ruleForm.country_code =  ''
    },
    /**
     * @description: 重置移动端签约人表单
     * @return {*}
     */
     resetEditForm() {
      this.editPartyForm = {
        last_use: 1,
        name:'',
        card_id:'',
        phone:'',
        country_type:1,
        province:'',
        city:'',
        area:'',
        address:'',
        country_code:'',
      }
    },
    /**
     * @description: 查看商品
     * @return {*}
     */
    selectAccount() {
      if(this.userToken){
        window.open(`${process.env.VUE_APP_H5_WEBSITE}/pages/product/detail?game_id=${this.ruleForm.game_id}&id=${this.ruleForm.product_id}&gameName=${this.ruleForm.game_name}`,'_blank')
      } else {
        window.open(`${process.env.VUE_APP_WEBSITE}/gamedetails?game_id=${this.ruleForm.game_id}&id=${this.ruleForm.product_id}&order_id=${this.order_id}&source_page=${this.$route.path.slice(1)}`,'_blank')
      }
    },
    validatearmsData(rule, value, callback) {
      if(value == 0){
        return callback(new Error('请完成实名认证！'));
      } else {
        callback();
      }
    },
    closeRealNameDialog() {
      this.showRealNameDialog = false
      location.href = `/submitOutcome?r=${this.room_id}&a=${this.admin_id}&o=${this.order_id}${this.userToken?'&t=' + this.userToken: ''}`
    },
    goRealName() {
      this.showRealNameDialog = false
      this.underage = false
      window.open(this.readnameUrl)
      this.goRealNameTime = 3
      this.readnameUrl = ''
      location.href = `/submitOutcome?r=${this.room_id}&a=${this.admin_id}&o=${this.order_id}${this.userToken?'&t=' + this.userToken: ''}`
    },
    realNameCountdown() {
      setTimeout(() => {
        if (!this.showRealNameDialog) {
          return
        }
        if (this.goRealNameTime-- === 1) {
          this.goRealName()
          // document.getElementById("my-dialog-btn").click()
          return
        }
        this.realNameCountdown()
      }, 1000);
    },
    saveInfo() {
      let param = JSON.parse(JSON.stringify(this.ruleForm))
      if(param.contract_agent_sign == 1 || this.underage){
        param.address = ''
        param.sign_user_id = this.signActiveId
      } else {
        param.sign_user_id = ''
        if(param.country_type == 2){
          param.province = ''
          param.city = ''
          param.area = ''
          if(param.country_code == ''){
            this.$message({
              message: '请选择国家',
              center: true,
              offset: 200,
              customClass: 'sell-contract-msg'
            })
            return
          }
        }else{
          if(param.province == ''){
            this.$message({
              message: '请选择省份',
              center: true,
              offset: 200,
              customClass: 'sell-contract-msg'
            })
            return
          } else if(param.city == '' && this.cityList.length > 0) {
            this.$message({
              message: '请选择城市',
              center: true,
              offset: 200,
              customClass: 'sell-contract-msg'
            })
            return
          } else if (this.districtList.length>0 && param.area == ''){
            this.$message({
              message: '请选择区县',
              center: true,
              offset: 200,
              customClass: 'sell-contract-msg'
            })
            return
          }
          param.country_code = '86'
        }
      }
      if(param.acc_source != 1){
        param.acc_source_img = ''
      }
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          if(this.ruleForm.contract_agent_sign == 1 && (this.partyData.length<=0 || this.signActiveId == '')){
            this.$message({
              message: '请选择签署人',
              center: true,
              offset: 200,
              customClass: 'sell-contract-msg'
            })
            this.btnLoading = false
            return
          }
          apiContractSellerInformationAdd({
            client: this.userToken ? 'moblie' : 'front',
            ...param,
            order_id: this.order_id,
            admin_id: this.admin_id,
            room_id: this.room_id,
            rd: this.$route.query.rd
          }).then(res =>{
            // 法大大实名未认证，优先跳转认证 实名弹窗不阻塞
            const readnameUrl = res.data.auth_url
            if(readnameUrl) {
              this.readnameUrl = readnameUrl
              this.showRealNameDialog = true
              // if (!this._isMobile()) {
              //   this.realNameCountdown()
              // }
            } else {
              this.underage = false
              location.href = `/submitOutcome?r=${this.room_id}&a=${this.admin_id}&o=${this.order_id}${this.userToken?'&t=' + this.userToken: ''}`
            }
            setTimeout(() => {
              this.btnLoading = false
            }, 400)
          }).catch(err => {
            this.$message({
              message: err.msg,
              center: true,
              offset: 200,
              customClass: 'sell-contract-msg'
            })
            this.btnLoading = false
          })
        }else{
          scrollIntoView()
          this.$message({
            message: '请正确填写相关信息',
            center: true,
            offset: 200,
            customClass: 'sell-contract-msg'
          })
        }
      })
    },
    provinceChange(e,flag) {
      if(e == ''){
        this.cityList = []
      } else {
        this.cityList = this.ChinaAddressArea.filter(item => item.value == e)[0].children || []
        this.districtList = []
        this.editPartyForm.city = ''
        this.editPartyForm.area = ''
      }
      if(flag){
        this.cityChange(this.ruleForm.city,true)
      }else{
        this.ruleForm.city = ''
        this.ruleForm.area = ''
        this.editPartyForm.city = ''
        this.editPartyForm.area = ''
      }
    },
    cityChange(e,flag) {
      if(e == ''){
        this.districtList = []
      } else {
        this.districtList = this.cityList.filter(item => item.value == e)[0].children || []
        this.editPartyForm.area = ''
      }
      if(flag){}else{
        this.ruleForm.area = ''
        this.editPartyForm.area = ''
      }
    },
    realNameSubmit(data) {
      this.ruleForm.auth_state = 1
      this.ruleForm.cert_name = data.name
      this.ruleForm.card_id = data.card_id
      this.ruleForm.frontIdPhoto = data.frontIdPhoto
      this.ruleForm.backIdPhoto = data.backIdPhoto
      this.$refs.ruleForm.validateField('auth_state');
    },
    delAccImg() {
      this.ruleForm.acc_source_img = ''
    },
    delOthenImg() {
      this.partyData[this.signActiveIndex].other_order_img = ''
      this.ruleForm.other_order_img = ''
    },
    /**
     * @description: 生成唯一标识
     * @return {*}
     */
     uuid() {
      let s = [];
      let hexDigits = "0123456789abcdef";
      for (let i = 0; i < 36; i++) {
          s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";
      let uuid = s.join("");
      return uuid;
    },
    async uploadCardBehind(file,key) {
      const isJPG = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png' || file.raw.type === 'image/bmp';
      if (!isJPG) {
        this.$message({
          message: '凭证截图只能是jpg/jpeg/png/bmp格式!',
          center: true,
          offset: 200,
          customClass: 'sell-contract-msg'
        })
        return
      }
      this.loadingback = true
      let newFile = await imageConversion.compressAccurately(file.raw, {
        size: 1024,
        type: 'image/jpeg'
      })
      file.raw = new File([newFile],this.uuid()+".jpeg",{type:file.type,lastModified: Date.now()})
      let formData = new FormData()
      formData.append('file', file.raw)
      apiSellCard(this.app_status,formData).then(res => {
        this.ruleForm[key] = res.data.url
        if(key == 'other_order_img'){
          this.partyData[this.signActiveIndex].other_order_img = res.data.url
        }
        this.loadingback = false
      }).catch(e => {
        this.loadingback = false
      })
    },
    _isMobile() {
      return is_mobile;
    },
    //实名认证
    certification() {
      if(this.ruleForm.auth_state == 0){
        this.step = 2
      }else{
        this.$message({
          message: '已实名',
          center: true,
          offset: 200,
          customClass: 'sell-contract-msg'
        })
      }
      // this.$router.push({ path: "/realnameCertification" });
    },
    async upload(file) {
      this.loading = true;
      const isJPG =
        file.raw.type === "image/jpeg" || file.raw.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message({
          message: "上传图片只能是 JPG/PNG 格式!",
          center: true,
          offset: 200,
          customClass: "sell-contract-msg",
        });
        return;
      }
      let newFile = await imageConversion.compressAccurately(file.raw, {
        size: 900,
        type: "image/jpeg",
      });
      let blob_file = new File([newFile], this.uuid() + ".jpeg", {
        type: file.type,
        lastModified: Date.now(),
      });
      let formData = new FormData();
      formData.append("file", blob_file);
      apiSellCard(this.app_status, formData)
        .then((resp) => {
          appAliyunAuth(this.app_status, {
            url: resp.data.url,
          })
            .then((res) => {
              if (
                this.form.card_id != "" &&
                this.form.card_id != null &&
                this.form.card_id != res.data.cert_id
              ) {
                this.$message({
                  message: "上传身份证与法大大实名不一致",
                  center: true,
                  offset: 200,
                  customClass: "sell-contract-msg",
                });
                this.loading = false;
                this.frontIdPhoto_url = "";
                return;
              } else {
                this.form.frontIdPhoto = resp.data.uri;
                this.frontIdPhoto_url = resp.data.url;
                this.form.name = res.data.cert_name;
                this.form.card_id = res.data.cert_id;
                if (this.form.name == "" || this.form.card_id == "") {
                  this.frontIdPhoto_url = "";
                  this.$message({
                    message: "验证失败，请重新上传",
                    center: true,
                    offset: 200,
                    customClass: "sell-contract-msg",
                  });
                } else {
                  this.frontIdPhotoShow = false;
                  this.$message({
                    message: "验证通过",
                    center: true,
                    offset: 200,
                    customClass: "sell-contract-msg",
                  });
                }
                this.loading = false;
              }
            })
            .catch((err) => {
              this.$message({
                message: err.msg,
                center: true,
                offset: 200,
                customClass: "sell-contract-msg",
              });
              this.loading = false;
            });
        })
        .catch((err) => {
          this.$message({
            message: err.msg,
            center: true,
            offset: 200,
            customClass: "sell-contract-msg",
          });
          this.loading = false;
        });
    },

    /**
     * 获取签约人列表
     */
    getSignatoryList(){
      signatoryList({
        client: this.userToken ? 'moblie' : 'front'
      }).then(res=>{
        this.partyData = res.data
        this.handleActive({id: this.partyData[0]?.id, index: 0})
      })
    },


  },
};
</script>

<style lang="less">
@import "./styles/contractFeedback.less";
</style>

<style lang="less" scoped>
@import "./styles/contractFormPage.less";

.contract-form-page(72px, sellerInformation, sellerInformation-top, sellerInformation-main, sellerInformation-btn);

.dialog-realname {
  margin-top: 12px;
  color: #999;
  i {
    color: #F0EDE8;
  }
}
/deep/.el-upload--picture-card{
  width: 100px;
  height: 100px;
  line-height: 100px;
  overflow: hidden;
  border-radius: 4px;
}
.certContractSign {
  width: 100vw;
  min-height: 100vh;
  background: linear-gradient(
    to bottom,
    #D8D2CA 0%,
    #D8D2CA 278px,
    #f9fafb 278px,
    #f9fafb 100%
  );

  &-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1160px;
    // height: 199px;
    height: 156px;
    padding: 0 16px 0 24px;
    margin: 0 auto;

    &-text {
      &-title {
        font-size: 24px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        margin: 0 0 8px;
      }

      &-sn {
        font-size: 20px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
      }
    }

    &-logo {
      img {
        width: 254.28px;
        height: 68.34px;
      }
    }
  }

  &-card {
    width: 1200px;
    // height: 773px;
    // height: 995px;
    background: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
    border-radius: 4px 4px 4px 4px;
    margin: 0 auto;
    overflow: auto;

    &-body {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      // height: 100%;
      padding: 80px 80px 98px;
      &-form {
        width: 100%;
        height: 100%;
        .el-radio {
          margin-right: 80px;
        }
        .prop-fail {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          width: 85%;
          height: 17px;
          font-size: 12px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #ff7979;
          img {
            width: 13px;
            height: 13px;
          }
        }
        &-top {
          &-title {
            display: flex;
            align-items: center;
            padding-bottom: 20px;
            border-bottom: 1px solid #dee3ec;
            &-gameinfo {
              font-size: 18px;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600;
              color: #333333;
            }
            img {
              width: 12px;
              height: 12px;
              display: inline-block;
              margin: 0 1px 0 8px;
            }
            &-search {
              font-size: 12px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #F0EDE8;
              cursor: pointer;
            }
          }
          &-content {
            margin-top: 30px;
            &-uploadimg {
              &-text {
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                margin-bottom: 60px;

              }
              &-img {
                height: 100px;
                display: flex;
                margin-top: 10px;
                &-left {
                  width: 100px;
                  height: 100px;
                }
                &-right {
                  width: 16px;
                  height: 16px;
                  cursor: pointer;
                }
                .upload-box{
                  position: relative;
                  .delete{
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100px;
                    height: 100px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: rgba(0, 0, 0, 0.5);
                    border-radius: 4px;
                    i{
                      color: #ffffff;
                      font-size: 16px;
                    }
                  }
                }
              }
              &-tip {
                width: 9px;
                height: 20px;
                font-size: 16px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #ff0e0e;
                margin-right: 6px;
              }
            }
          }
        }
        &-bottom {
          .abroad {
            &-select {
              width: 26%;
              margin-right: 15px;
            }
            .el-input {
              width: 57%;
            }
          }
          &-tip {
            font-size: 12px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
          }
          &-content {
            margin-top: 55px;
            &-realname {
              font-size: 14px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #F0EDE8;
              cursor: pointer;
              .el-input {
                width: 85% !important;
              }
            }
            &-province {
              display: flex;
              justify-content: space-between;
              width: 85% !important;
              .el-select {
                width: 30%;
              }
            }
            &-address {
              margin-top: 15px;
              width: 85%;
            }
          }
          &-btn {
            width: 100%;
            margin-top: 80px;
            display: flex;
            justify-content: center;
            button {
              width: 250px;
              border-radius: 4px;
              font-size: 18px;
              font-weight: 500;
              text-align: center;
            }
            &-reset {
              margin-right: 30px;
              border: 1px #000 solid;
            }
            &-sub {
              border: 1px #ffdb51 solid;
              background-color: #ffdb51;
              color: #000;
            }
          }
          &-img {
            width: 400px;
            height: 33px;
            background: #f0f4ff;
            border-radius: 4px 4px 4px 4px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 57px;
            img {
              width: 22.94px;
              height: 13px;
              margin-right: 6px;
            }
            span {
              font-size: 14px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #5A5F6B;
            }
          }
        }
      }

      &-img {
        img {
          width: 211px;
          height: 249px;
        }
      }

      &-content {
        margin: 42px 0 68px;

        div {
          text-align: center;
        }

        div:first-of-type {
          font-size: 20px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #F0EDE8;
          margin: 0 0 4px;
        }

        div:last-of-type {
          font-size: 16px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #666666;
        }
      }

      &-btn {
        width: 150px;
        height: 40px;
        line-height: 40px;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        border: 1px solid #F7F5F2;
        text-align: center;
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #F7F5F2;
        cursor: pointer;
      }
    }
  }

  @media screen and (max-width: 1300px) {
    &-head {
      justify-content: center;
      width: 100%;
      height: 174px;
      padding: 0;

      &-logo {
        display: none;
      }
    }

    &-card {
      width: calc(100% - 22px * 2);
      margin: 0 24px 40px;
      // height: 625px;

      &-body {
        height: 100%;

        &-content {
          margin: 19px 0 60px;
          div:first-of-type {
            margin: 0 0 8px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 900px) {
    background: none;
    &-head {
      background-image: url("~@/assets/image/Contract/sell-img.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: 100% 90%;
      align-items: flex-start;
      &-text {
        margin-top: 13px;
        &-title {
          margin: 0 0 8px;
        }
        &-sn {
          font-size: 14px;
        }
      }
    }
    &-card {
      margin-top: -87px;
      overflow-x: hidden;
      .realInfo {
        position: relative;
        .real {
          position: absolute;
          top: -40px;
          right: 0;
        }
      }
      &-body {
        padding: 20px 40px 0;
        &-form {
          .prop-fail {
            width: 100%;
            right: 0;
          }
          &-top {
            ::v-deep .el-form-item {
              margin-bottom: 0;
            }
            &-title {
              padding-bottom: 0;
              border-bottom: none;
            }
            &-gameinfo {
              font-size: 16px;
              font-weight: 500;
            }
            &-content {
              ::v-deep .el-form-item .el-form-item__label {
                padding: 0;
                margin: 20px 0;
              }
              ::v-deep .el-form-item__label {
                line-height: 0;
              }
              ::v-deep .el-radio__label {
                font-size: 12px;
              }
              margin-top: 20px;
              .el-radio-group {
                margin-top: 10px;
                display: flex;
                justify-content: space-between;
                .el-radio {
                  margin-right: 0;
                  margin: 10px 0;
                  ::v-deep .el-radio__label {
                    padding-left: 3px;
                  }
                  .el-radio:nth-child(2) {
                    margin: 0 49px;
                  }
                }
              }
              &-uploadimg {
                margin-left: 0;
                &-text {
                  font-size: 12px;
                }
              }
            }
          }
          .province {
            justify-content: space-around;
            width: 100% !important;
          }

          &-bottom {
            ::v-deep .el-radio-group {
              display: flex;
            }
            ::v-deep .el-radio__label {
              font-size: 12px;
              padding-left: 5px;
              margin-right: 38px;
            }
            .el-radio {
              margin-right: 0;
            }
            &-content {
              margin-top: 30px;
              &-realname {
                .el-input {
                  width: 100% !important;
                }
              }
              .realInfo {
                .real {
                  font-size: 12px;
                }
              }
              &-address {
                width: 100%;
              }
              margin-top: 0;
              ::v-deep .el-form-item {
                margin-bottom: 0;
              }
              ::b-deep .el-form-item__label:nth-child(1) {
                font-size: 14px;
              }
              ::v-deep .el-input__inner {
                width: 100%;
                font-size: 12px;
              }
            }
            &-btn {
              margin-top: 40px;
              button {
                width: 150px;
                height: 40px;
                font-size: 16px;
                padding: 0;
                line-height: 0;
              }
              &-reset {
                margin-right: 20px;
              }
            }
            &-img {
              width: 375px;
              height: 33px;
              background: #f0f4ff;
              margin-top: 13px;
              img {
                width: 20px;
                height: 11.76px;
                margin-right: 6px;
              }
              span {
                font-size: 12px;
              }
            }
            ::v-deep .el-form-item__label {
              padding: 0;
              line-height: 0;
              margin: 20px 0;
              color: #666666;
            }
            .abroad {
              &-select {
                width: 35%;
                margin-right: 4px;
              }
              .el-input {
                width: 62%;
              }
            }
          }
        }
        &-img {
          img {
            width: 145px;
            height: 171.11px;
          }
        }
      }
    }
    .select /deep/ .el-input__inner {
      width: 100%;
    }
    .bottom-title {
      margin-top: 52px;
    }
  }
}

.sellerInformation {
  min-height: 100vh;

  .sellerInformation-main {
    .certContractSign-card-body {
      width: 100%;
      box-sizing: border-box;
      align-items: stretch;
      padding: 80px 80px 0;
    }

    .certContractSign-card-body-form {
      width: 100%;
    }

    .certContractSign-card-body-form-top-title {
      border-bottom-color: var(--border-soft, #E8E4DE);
    }
  }

  .sellerInformation-btn {
    button.sub {
      margin-left: 0;
    }
  }

  @media screen and (max-width: 900px) {
    .sellerInformation-main {
      .certContractSign-card-body {
        padding: 20px 40px 0;
      }
    }
  }
}
</style>
